<template>
  <a
    href="#"
    class="tw-flex tw-items-center tw-gap-2.5 tw-px-[18px] tw-py-3 tw-h-full !tw-no-underline tw-rounded-[100px] tw-text-center tw-text-[#387DFF] tw-text-center tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[100%] tw-font-[Poppins] tw-border-2 tw-border-solid tw-border-[#387DFF] button"
    @click.prevent="$emit('click')"
    >{{ title }}</a
  >
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  components: {},
})
export default class Button2 extends Vue {
  @Prop({ required: false, default: "Button" }) readonly title: string = "";
}
</script>
